import React from 'react';

const MessagePreview = ({ 
  activeTab, 
  message, 
  buttons = [], 
  image = null, 
  siteName = "캠핑장", 
  classification = "SMS" 
}) => {
  const renderSMSPreview = () => (
    <div className="message-preview sms-preview">
      <div className="phone-mockup">
        <div className="phone-screen">
          <div className="message-header">
            <div className="sender-info">
              <strong>{siteName}</strong>
              <span className="time">오후 2:30</span>
            </div>
          </div>
          <div className="message-bubble sms-bubble">
            <div className="message-content">
              {message || "메시지 내용을 입력하세요"}
            </div>
            <div className="message-time">오후 2:30</div>
          </div>
        </div>
      </div>
    </div>
  );

  const renderKakaoPreview = () => (
    <div className="message-preview kakao-preview">
      <div className="phone-mockup">
        <div className="phone-screen kakao-screen">
          <div className="kakao-header">
            <div className="profile-section">
              <div className="profile-image">
                <div className="profile-placeholder">{siteName.charAt(0)}</div>
              </div>
              <div className="profile-info">
                <div className="profile-name">{siteName}</div>
                <div className="message-type-badge">
                  {activeTab === 'alimtalk' ? '알림톡' : '친구톡'}
                </div>
              </div>
            </div>
            <div className="time">오후 2:30</div>
          </div>
          
          <div className="kakao-message-bubble">
            {image && activeTab === 'friendtalk' && (
              <div className="message-image">
                <img 
                  src={image.url} 
                  alt="메시지 이미지" 
                  style={{ 
                    width: '100%', 
                    maxHeight: image.is_wide ? '200px' : '300px',
                    objectFit: 'cover',
                    borderRadius: '8px'
                  }} 
                />
              </div>
            )}
            
            <div className="message-content">
              {message || "메시지 내용을 입력하세요"}
            </div>
            
            {buttons && buttons.length > 0 && (
              <div className="message-buttons">
                {buttons.map((button, index) => (
                  <button key={index} className="kakao-button">
                    {button.name}
                  </button>
                ))}
              </div>
            )}
            
            <div className="message-time">오후 2:30</div>
          </div>
          
          {activeTab === 'alimtalk' && (
            <div className="alimtalk-footer">
              <small className="text-muted">카카오 알림톡</small>
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <div className="card message-preview-card">
      <div className="card-header">
        <div className="d-flex justify-content-between align-items-center">
          <h6 className="card-title mb-0">메시지 미리보기</h6>
          <span className={`badge ${activeTab === 'sms' ? 'bg-primary' : 'bg-success'}`}>
            {activeTab === 'sms' ? classification : activeTab === 'alimtalk' ? '알림톡' : '친구톡'}
          </span>
        </div>
      </div>
      <div className="card-body">
        {activeTab === 'sms' ? renderSMSPreview() : renderKakaoPreview()}
        
        <div className="preview-info mt-3">
          <small className="text-muted">
            * 실제 수신 화면과 다를 수 있습니다
          </small>
        </div>
      </div>
      
      <style jsx>{`
        .message-preview-card {
          position: sticky;
          top: 20px;
        }
        
        .phone-mockup {
          display: flex;
          justify-content: center;
          padding: 20px 0;
        }
        
        .phone-screen {
          width: 280px;
          min-height: 400px;
          background: #f8f9fa;
          border-radius: 20px;
          padding: 20px 15px;
          box-shadow: 0 4px 20px rgba(0,0,0,0.1);
          position: relative;
        }
        
        .kakao-screen {
          background: #b2c7da;
        }
        
        /* SMS Styles */
        .message-header {
          margin-bottom: 15px;
        }
        
        .sender-info {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #666;
          font-size: 14px;
        }
        
        .sms-bubble {
          background: #007bff;
          color: white;
          padding: 12px 16px;
          border-radius: 18px;
          border-bottom-right-radius: 4px;
          max-width: 85%;
          margin-left: auto;
          position: relative;
        }
        
        .message-content {
          font-size: 14px;
          line-height: 1.4;
          word-wrap: break-word;
          white-space: pre-wrap;
        }
        
        .message-time {
          font-size: 11px;
          opacity: 0.7;
          margin-top: 5px;
        }
        
        /* KakaoTalk Styles */
        .kakao-header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 15px;
          color: white;
        }
        
        .profile-section {
          display: flex;
          align-items: center;
        }
        
        .profile-image {
          width: 40px;
          height: 40px;
          margin-right: 10px;
        }
        
        .profile-placeholder {
          width: 100%;
          height: 100%;
          background: #ffcd00;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-weight: bold;
          color: #333;
        }
        
        .profile-name {
          font-weight: bold;
          font-size: 14px;
        }
        
        .message-type-badge {
          font-size: 12px;
          opacity: 0.8;
        }
        
        .time {
          font-size: 12px;
        }
        
        .kakao-message-bubble {
          background: white;
          border-radius: 12px;
          padding: 12px;
          margin-bottom: 10px;
          box-shadow: 0 1px 3px rgba(0,0,0,0.1);
        }
        
        .message-image {
          margin-bottom: 10px;
          border-radius: 8px;
          overflow: hidden;
        }
        
        .message-buttons {
          margin-top: 10px;
          display: flex;
          flex-direction: column;
          gap: 8px;
        }
        
        .kakao-button {
          background: #f8f9fa;
          border: 1px solid #dee2e6;
          padding: 8px 12px;
          border-radius: 6px;
          font-size: 13px;
          cursor: pointer;
          transition: background-color 0.2s;
        }
        
        .kakao-button:hover {
          background: #e9ecef;
        }
        
        .alimtalk-footer {
          text-align: center;
          margin-top: 10px;
        }
        
        .preview-info {
          text-align: center;
          border-top: 1px solid #dee2e6;
          padding-top: 10px;
        }
      `}</style>
    </div>
  );
};

export default MessagePreview;
